export const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  maxWidth: '320px',
};

export const reasonsListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  margin: 0,
  paddingLeft: '16px',
};

export const hintStyles = {
  color: ({ palette }) => palette.text.secondary,
};
